<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>CASO {{ incident?.id }}</h1>
        </div>
        <div class="card-container">
            <mat-card
                class="mat-elevation-z8 custom-mat-card-sub custom-card-header"
            >
                <mat-card-header class="custom-card-header">
                    <mat-card-title>
                        <p><b>DETALLES DEL INCIDENTE</b></p>
                    </mat-card-title>
                    <mat-card-subtitle
                        ><p>
                            <b>Código:</b>
                            {{ incident?.code }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle>
                        <b>Hecho victimizante:</b>

                        <ng-container
                            *ngIf="incident?.violence?.length; else noViolence"
                        >
                            <ul class="list-none p-0 m-0">
                                <li *ngFor="let v of incident?.violence">
                                    {{ v.name }}
                                </li>
                            </ul>
                        </ng-container>

                        <ng-template #noViolence>No registra</ng-template>
                    </mat-card-subtitle>

                    <mat-card-subtitle
                        ><p>
                            <b>Lugar del hecho:</b>
                            {{ incident?.location?.city }},
                            {{ incident?.address?.territory }},
                            {{ incident?.address?.street }},
                            {{ incident?.address?.complement }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle
                        ><p>
                            <b>Fecha del suceso:</b>
                            {{ incident?.date | date }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle
                        ><p>
                            <b>Fecha de registro:</b>
                            {{ incident?.createdAt | date }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle
                        ><p>
                            <b>Descripción del caso:</b>
                            {{
                                incident?.secure
                                    ? 'Dato encriptado'
                                    : incident?.description
                            }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-title>
                        <p><b>TESTIGOS DEL HECHO</b></p>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <ng-container
                            *ngIf="
                                (incident?.witnesses?.length ?? 0) > 0;
                                else noWitness
                            "
                        >
                            <ol>
                                <li *ngFor="let w of incident?.witnesses">
                                    <p>
                                        <b>Número de identificación: </b
                                        >{{ w.identificationCode }}<br />
                                        <b>Tipo de identificación: </b>
                                        {{ w.identificationType }}<br />
                                        <b>Nombres y apellidos: </b>{{ w.name }}
                                        {{ w.lastName }}<br />
                                        <b>Contacto: </b>{{ w.phone }}
                                    </p>
                                </li>
                            </ol>
                        </ng-container>
                        <ng-template #noWitness>Sin registro</ng-template>
                    </mat-card-subtitle>
                    <mat-card-title>
                        <p><b>VÍCTIMAS</b></p>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <ng-container
                            *ngIf="
                                (incident?.victims?.length ?? 0) > 0;
                                else noVictims
                            "
                        >
                            <ol>
                                <li *ngFor="let v of incident?.victims">
                                    <mat-card-subtitle
                                        ><p>
                                            <b>INFORMACIÓN GENERAL</b>
                                        </p></mat-card-subtitle
                                    >
                                    <p>
                                        <b>Número de identificación: </b
                                        >{{ v.identificationCode }}<br />
                                        <b>Tipo de identificación: </b>
                                        {{ v.identificationType }}<br />
                                        <b>Nombres y apellidos: </b>{{ v.name }}
                                        {{ v.lastName }}<br />
                                        <b>Fecha de nacimiento: </b
                                        >{{ v.birthDate | date }}<br />
                                        <b>Lugar de nacimiento: </b
                                        >{{ v.placeBirth.city }}<br />
                                        <b>Estado civil: </b
                                        >{{
                                            v.socioeconomicStatus
                                                .civilianStatus
                                        }}<br />
                                        <b>Género: </b>{{ v.sex }}<br />
                                        <b>Contacto: </b>{{ v.phone }}<br />
                                        <b>E-mail: </b>{{ v.email }}<br />
                                        <b>Territorio: </b
                                        >{{ v.address.territory }}<br />
                                        <b>Ocupación: </b>{{ v.profesion.name
                                        }}<br />
                                        <b>Nombre de la compañía: </b>
                                        {{ v.profesion.companyName }}<br />
                                        <b>Grupo cultural o étnico: </b>
                                        {{ v.socioeconomicStatus.culturaEthnic
                                        }}<br />
                                    </p>
                                </li>
                            </ol>
                        </ng-container>
                        <ng-template #noVictims>Sin registro</ng-template>
                    </mat-card-subtitle>
                    <mat-card-title>
                        <p><b>VÍCTIMARIOS</b></p>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <ng-container
                            *ngIf="
                                (incident?.perpetrors?.length ?? 0) > 0;
                                else noPerpetrors
                            "
                        >
                            <ol>
                                <li *ngFor="let p of incident?.perpetrors">
                                    <p>
                                        <b>Número de identificación: </b
                                        >{{ p.identificationCode }}<br />
                                        <b>Tipo de identificación: </b>
                                        {{ p.identificationType }}<br />
                                        <b>Nombres y apellidos: </b>{{ p.name }}
                                        {{ p.lastName }}<br />
                                        <b>Contacto: </b>{{ p.phone }}<br />
                                        <b>Género: </b>{{ p.sex }}<br />
                                        <b>Direccion: </b
                                        >{{ p.address.street }},
                                        {{ p.address.number }},
                                        {{ p.address.complement }}<br />
                                    </p>
                                </li>
                            </ol>
                        </ng-container>
                        <ng-template #noPerpetrors>Sin registro</ng-template>
                    </mat-card-subtitle>
                    <mat-card-subtitle>
                        <b>Grupo presunto responsable:</b>

                        <ng-container
                            *ngIf="
                                incident?.perpetrorsMetadata?.length;
                                else noPerpetrorsMetadata
                            "
                        >
                            <ul class="list-none p-0 m-0">
                                <li
                                    *ngFor="
                                        let v of incident?.perpetrorsMetadata
                                    "
                                >
                                    {{ v.organization }}
                                </li>
                            </ul>
                        </ng-container>

                        <ng-template #noPerpetrorsMetadata
                            >No registra</ng-template
                        >
                    </mat-card-subtitle>
                    <mat-card-title
                        ><br />
                        <p><b>DETALLES DEL REGISTRO</b></p>
                    </mat-card-title>
                    <mat-card-subtitle
                        ><p>
                            <b>Fecha de creación:</b>
                            {{ incident?.createdAt | date }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle
                        ><p>
                            <b>Creador por:</b>
                            {{ incident?.createdBy?.username }} -
                            {{ incident?.createdBy?.first_name }}
                            {{ incident?.createdBy?.last_name }}
                        </p></mat-card-subtitle
                    >
                    <mat-card-subtitle
                        ><p>
                            <b>Editado por:</b>
                            {{ incident?.createdBy?.username }} -
                            {{ incident?.createdBy?.first_name }}
                            {{ incident?.createdBy?.last_name }}
                        </p></mat-card-subtitle
                    >
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>
